<p-toast></p-toast>

<section class="admin-page">
    <app-admin-page-header [title]="title" [subtitle]="subtitle">
        <div header-actions style="display: contents">
            <a class="admin-btn admin-btn--secondary"
                href="https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=2261833930864844&tab=message-templates&filters=%7B%22date_range%22%3A7%2C%22language%22%3A[]%2C%22quality%22%3A[]%2C%22search_text%22%3A%22%22%2C%22status%22%3A[%22APPROVED%22%2C%22IN_APPEAL%22%2C%22PAUSED%22%2C%22PENDING%22%2C%22REJECTED%22]%2C%22tag%22%3A[]%7D&nav_ref=whatsapp_manager&asset_id=2026273278300979"
                target="_blank" rel="noopener noreferrer">
                Templates de WhatsApp
            </a>
            <a class="admin-btn admin-btn--secondary" href="https://resend.com/templates" target="_blank"
                rel="noopener noreferrer">
                Templates de Email
            </a>
            <button class="admin-btn admin-btn--primary" type="button" (click)="openCreateCampaignDialog()">
                Nova Campanha
            </button>
        </div>
    </app-admin-page-header>

    <div class="admin-surface admin-surface__section">
        <div class="admin-detail-card">
            <p-table [value]="campaigns" [paginator]="true" [rows]="rowsPerPage" [totalRecords]="totalCampaigns"
                [lazy]="true" [loading]="isLoadingCampaigns" (onLazyLoad)="onLazyLoad($event)"
                styleClass="admin-table hoverable">
                <ng-template pTemplate="header">
                    <tr>
                        <th>ID</th>
                        <th>Criação</th>
                        <th>Cluster</th>
                        <th>Descrição do Cluster</th>
                        <th>Canais</th>
                        <th>Envios</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-campaign>
                    <tr (click)="seeCampaignDetails(campaign.id)">
                        <td>{{campaign.id}}</td>
                        <td>{{campaign.created_at | date: "dd/MM/yyyy HH:mm"}}</td>
                        <td>{{campaign.cluster.name}}</td>
                        <td>{{campaign.cluster.description}}</td>
                        <td>{{campaign.channels}}</td>
                        <td>{{campaign.recipients_count}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <p-dialog header="Criar Nova Campanha" styleClass="admin-dialog" [(visible)]="displayCreateCampaignModal"
        [modal]="true" maskStyleClass="dialog-mask" [dismissableMask]="true" [draggable]="false" [appendTo]="'body'"
        [style]="{width: '80vw'}">
        <app-campaign-form (campaignCreated)="createCampaignSucess()"></app-campaign-form>
    </p-dialog>
</section>